import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import styles from "./listtable.module.scss";
import AvatarC from "../../common/avatar";
import {
  countDaysFromDate,
  formatCurrency,
  StatusObjectColorFilter
} from "../../../utils/utils";
import { useNavigate } from "react-router-dom";
import { Property } from "./property-list.interface";
import useProperty from "../../../hooks/context/useProperty";
import { Tag } from "primereact/tag";
import Like from "../../common/like";
import moment from "moment";
import { NavigateToExchange } from "../../../utils/inv-exch-amplitude";
import { NavigatePropertyDetail } from "../../investor/amplitude";
import PriceDropTag from "../../common/pricedrop-tag";
import { Tooltip } from "primereact/tooltip";

interface PageData {
  data: { properties: Property[] } | Property[];
}
const ListTable = (props: any) => {
  const navigate = useNavigate();
  
  // Helper function to get properties based on type
  const getProperties = (pageData: any) => {
    return props.type === "investor" ? pageData : pageData?.properties;
  };
  
  const [propertyArr, setProperty] = useState((preProperties: any): any => {
    if (props.arrProperty?.pages) {
      const allPro: any = [];
      props.arrProperty?.pages.forEach((page: PageData) => {
        if (page.data) {
          const properties = getProperties(page.data);
          properties?.forEach((element: Property) => {
            allPro.push(element);
          });
        }
      });
      return allPro;
    }
  });

  useEffect(() => {
    if (props.arrProperty?.pages) {
      const allPro: any = [];
      props.arrProperty?.pages.forEach((page: PageData) => {
        if (page?.data) {
          const properties = getProperties(page.data);
          properties?.forEach((element: Property) => {
            allPro.push(element);
          });
        }
      });
      setProperty(allPro);
    }
  }, []);

  useEffect(() => {
    if (props.arrProperty?.pages) {
      const allPro: any = [];
      props.arrProperty?.pages.forEach((page: PageData) => {
        if (page?.data) {
          const properties = getProperties(page.data);
          properties?.forEach((element: Property) => {
            allPro.push(element);
          });
        }
      });
      setProperty(allPro);
    }
  }, [props.arrProperty]);

  const navigateOnClick = (e: any) => {
    if (props.type === "agent") {
      navigate(`/internal/${e.data.id}`);
    } else {
      navigate(`/external/${e.data.shareKey}`);
      NavigatePropertyDetail({
        propertyId: e.data?.id,
        propertySFID: e.data?.propertySFID,
        opportunitySFID: e.data?.opportunitySFID,
        pubPropertySFID: e.data?.pubPropertySFID,
        shareId: e.data?.shareKey,
        address: e.data?.address,
        bedRooms: e.data?.bedRooms,
        baths: e.data?.baths,
        sqft: e.data?.sqft,
        askingPrice: e.data?.askingPrice
      });
    }
  };

  const addressTemplate = (objProperty: any) => {
    const status = StatusObjectColorFilter(objProperty?.status);
    return (
      <div className={`${styles.imgWrap} ${styles.tableCell}`}>
        <div className={styles.img}>
          <img
            src={objProperty?.posterImage ?? "/images/default-property.jpg"}
            alt="Image"
            className={styles.propertyImg}
          />
          {props.type === "agent" && (
            <div className={styles.daysCount}>
              <Tag
                value={
                  countDaysFromDate(objProperty?.createdAt) > 1
                    ? `${countDaysFromDate(objProperty?.createdAt)} Days ago`
                    : `${countDaysFromDate(objProperty?.createdAt)} Day ago`
                }
                style={{
                  background: "#0000008a",
                  color: "#ffffff"
                }}
                className={styles.tagClass}
              />
            </div>
          )}
        </div>
        <div className={styles.address}>
          <span>{objProperty?.street}</span>
          <span className={styles.text}>
            {objProperty?.city}, {objProperty?.state} {objProperty?.postalcode}
          </span>
          <Tag
            value={objProperty?.status}
            style={{
              backgroundColor: status?.bgColor || "#0000008a",
              color: status?.txtColor || "#ffffff"
            }}
          />
          <Tag
            value={objProperty?.salesInstruction}
            style={{
              background: "#0000008a",
              color: "#ffffff",
              marginLeft: "5px"
            }}
          />
        </div>
      </div>
    );
  };

  const agentTemplate = (objProperty: any) => {
    return (
      <div className={`${styles.agent} ${styles.tableCell}`}>
        {objProperty?.acquisitionAgent1?.name && (
          <>
            <AvatarC
              size="normal"
              shape="circle"
              label={`${objProperty?.acquisitionAgent1?.name?.slice(
                0,
                1
              )}${objProperty?.acquisitionAgent1?.name
                ?.split(" ")[1]
                ?.slice(0, 1)}`}
              // image={objProperty?.acquisitionAgent1?.smallBannerPhotoUrl}
            />
            <span className={styles.name}>
              {objProperty?.acquisitionAgent1?.name?.split(" ")[0] +
                " " +
                objProperty?.acquisitionAgent1?.name
                  ?.split(" ")[1]
                  ?.slice(0, 1)}
              .
            </span>
          </>
        )}
      </div>
    );
  };

  const likeTemplate = (objProperty: any) => {
    return (
      <Like
        loginType={props?.type}
        propertyId={objProperty.id}
        favCount={objProperty.favCount}
        width={25}
        objPropertyDetails={objProperty}
      />
    );
  };

  const currencyTemplate = (objProperty: any) => {
    return (
      <div className={`${styles.tableCell} ${styles.price}`}>
        {formatCurrency(objProperty.askingPrice, "USD", "en-US", 0, 0)}
        <PriceDropTag
          type={props?.type}
          priceDrop={objProperty?.priceDrop}
          priceDropDate={objProperty?.priceDropDate}
        />
      </div>
    );
  };

  const investorExchangeTemplate = (objProperty: any) => {
    const checkActivationTime = () => {
      if (objProperty?.activatedAt === null) return false;
      return (
        moment.utc().diff(moment.utc(objProperty?.activatedAt), "minutes") >=
        +`${process.env.REACT_APP_ACTIVE_TIMER}`
      );
    };
    return (
      <>
        {objProperty?.status === "Active" && (
          <div
            className={`exchange-${objProperty?.id} ${styles.findInvestor} ${
              checkActivationTime() ? styles.openButton : ""
            }`}
            onClick={(e) => {
              e?.stopPropagation();
              navigate(
                `/flipper-vault?pid=${objProperty?.id}&sfid=${
                  objProperty?.sfid
                }&lat=${objProperty?.latitude}&lng=${
                  objProperty?.longitude
                }&radius=60&shouldIgnoreRadius=true&price=${
                  objProperty?.askingPrice
                }&street=${encodeURIComponent(objProperty?.street || "")}&city=${encodeURIComponent(
                  objProperty?.city || ""
                )}&state=${encodeURIComponent(objProperty?.state || "")}&postalCode=${encodeURIComponent(
                  objProperty?.postalCode || ""
                )}&order=High+to+Low&showIEButton=${checkActivationTime()}&view=ALL+ACCOUNTS`
              );
              NavigateToExchange({
                property_id: objProperty?.id || "",
                property_sfid: objProperty?.sfid || "",
                property_address: `${objProperty?.street}, ${objProperty?.city}, ${objProperty?.state} ${objProperty?.postalCode}`
              });
            }}
          >
            <Tooltip
              position="bottom"
              target={`.exchange-${objProperty?.id}`}
              className={styles.tooltip}
              content={moment(objProperty?.activatedAt)
                .utc()
                .add(48, "hours")
                .local()
                .format("MM/DD/YY hh:mm A")}
            />
            <img src="/images/exchange.svg" alt="" width={20} height={20} />
          </div>
        )}
      </>
    );
  };

  const { setHoveredProperty } = useProperty();
  const handleRowMouseEnter = (property: Property) => {
    setHoveredProperty(property);
  };

  const handleRowMouseLeave = () => {
    setHoveredProperty(null);
  };

  return (
    <DataTable
      value={propertyArr}
      className={styles.tableClass}
      onRowClick={navigateOnClick}
      onRowMouseEnter={(e: any) => handleRowMouseEnter(e.data)}
      onRowMouseLeave={handleRowMouseLeave}
    >
      <Column body={addressTemplate} header="Address"></Column>
      {/* <Column body={instructionTemplate} header="Instructions"></Column> */}
      <Column
        body={currencyTemplate}
        header="Price"
        bodyClassName={styles.textRight}
        headerClassName={styles.textRight}
      ></Column>
      {props.type === "agent" && (
        <Column body={agentTemplate} header="Agent"></Column>
      )}
      {props.type === "agent" && (
        <Column
          body={investorExchangeTemplate}
          header="Investor Exchange"
        ></Column>
      )}
      <Column body={likeTemplate} header=""></Column>
    </DataTable>
  );
};

export default ListTable;
